// extracted by mini-css-extract-plugin
export default {"showMoreWrapper":"ShowMore_showMoreWrapper__F5AA0","showMore":"ShowMore_showMore__-m7mE"};